export async function fetchInteractivityPoll(
  episodeId: string
): Promise<InteractivityPollsResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/episodes/webEpisodeId:${episodeId}/poll`
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error('Response not ok');
  } catch (e) {
    console.warn('Error fetching from Interactivity API: ', e);
    throw new Error(e);
  }
}

export enum POLL_STATUS {
  LIVE = 'LIVE',
  DRAFT = 'DRAFT',
  CLOSED = 'CLOSED',
}

export type InteractivityPollsResponse = {
  polls: InteractivityPoll[];
};
export type InteractivityPoll = {
  id?: number;
  name: string;
  question: string;
  type: POLL_TYPE;
  status?: POLL_STATUS;
  opening_date: string | number;
  closing_date: string | number;
  options: Option[];
  entity_timestamp_ms?: number;
  published: boolean;
  blocked?: boolean;
  poll_metadata?: {
    created: string;
    created_by: string;
    poll_id: number;
  };
};
export enum POLL_TYPE {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}
export type Option = {
  description: string;
  total_votes?: number;
  poll_id?: number;
  option_id?: number;
};
